const create = () => {
  if (typeof window === 'undefined') return { DEBUG: '1' };
  const { _env: env } = window || {};

  // if (typeof window.Proxy !== 'undefined') {
  //   return new Proxy(env, {
  //     get(target, prop) {
  // eslint-disable-next-line max-len
  //       console.log(`config(): Accessing (exists: ${typeof target[prop] !== 'undefined'}): ${prop}`);
  //       return target[prop];
  //     },
  //   });
  // }

  return env || {};
};

export default create();
